<template>
    <div>
        <Modal v-model="show"
            :width="1300"
            :footer-hide="true"
            title="定金单废单明细"
            draggable
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <Form label-position="top"
                        class="form-input-no-outline">
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="订单号">
                                <Input :value="orderRecord.billCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="苗场">
                                <Input :value="orderRecord.seedFarmName"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="定单时间">
                                <Input :value="formatDateTimeString(orderRecord.depositBillRecordCreateAt)" readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="周期">
                                <Input :value="orderRecord.weekSeq"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="发货时间">
								<Input v-model="sendDeliveryDate" :value="formatDateString(orderRecord.depositBillRecordSendProductDate)"></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="支付状态">
                                <Input :value="orderRecord.paidStatus"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="定单总额(元)">
                                <Input :value="orderRecord.mainTotalMoney" readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <FormItem label="待付金额(元)">
                                <Input :value="orderRecord.remainingSum" readonly></Input>
                            </FormItem>
                            </Col>
                        </Row>
						<!-- 新增客户地址和苗场备注 -->
						<Row :gutter="24">
                            <Col span="4">
                            <FormItem label="关联销售单号">
                                <Input :value="orderRecord.preSaleOrderRecordCode" readonly></Input>
                            </FormItem>
                            </Col>
							<Col span="10">
							<FormItem label="客户地址">
							    <Input :value="orderRecord.receiptFullAddress" readonly></Input>
							</FormItem>
							</Col>

							<Col span="10">
							<FormItem label="苗场备注" v-if="$checkAccessArray(['B','C'])">
							    <Input :value="orderRecord.remark" readonly type="textarea"></Input>
							</FormItem>
							<FormItem label="苗场备注" v-if="$checkAccessArray(['S','G'])">
							    <Input :value="orderRecord.remark" readonly type="textarea"></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
							<Col span="8">
							<FormItem label="客户备注" v-if="$checkAccessArray(['S','B'])">
							    <Input :value="orderRecord.customerMsg" readonly type="textarea"></Input>
							</FormItem>
							</Col>
							<Col span="6">
							<FormItem label="佣金比例">
							    <Input :value="orderRecord.depositBillDetailSalesAssociateCommissionPercent" readonly ></Input>
							</FormItem>
							</Col>
						</Row>
                        <Row :gutter="24">
                            <Col span="24">
							<!-- <div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C','S','G'])">
								<Poptip
								   confirm
								   placement="left"
								   title="以第一行品种的单价为准,是否将全部品种的单价改成一样？"
								   @on-ok="updatePreSalePlanPrice"
								   @on-cancel="cancel" style="margin-right: 20px;text-align: left;">
								   <Button type="error">批量修改单价</Button>
								</Poptip>
								<Poptip
								   confirm
								   placement="left"
								   title="请确认信息是否无误？"
								   @on-ok="saveDetailInfo"
								   @on-cancel="cancel" style="text-align: left;">
								   <Button type="error">批量保存</Button>
								</Poptip>
							</div> -->
                            <FormItem>
                                <div slot="label"><b>定金单明细</b>
                                </div>
                                <Table ref="mainTable"
                                    size="small"
                                    :columns="orderDetail.columns"
                                    :data="orderDetail.rows"
                                    stripe
                                    border />
                            </FormItem>
                            </Col>
                        </Row>
                    </Form>

                    </Col>
                </Row>
				<div style="float:right;padding-bottom: 30px;">
				    <Button type="error"
				        @click="show=false">关闭</Button>
				</div>
            </Card>
        </Modal>
    </div>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import {
    dateRender,
    dateTimeRender
} from '@/libs/tableRowTimeRender';

import {
    getDepositBillOrderDetail, deleteDepositBillDetailByUuid, updateDepositBillDetailByUuid
} from '@/api/modules/preSale-management/deposit-order';
import {
    ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import {
    FILE_SERVER
} from '@/api/modules/files';
export default {
    name: 'AbandonedDepositDetail',
    components: {
        CurrencyInput,
        DecimalInput,
        IntegerInput
    },
    data() {
        return {
            sendDeliveryDate:'',
            show: false,
            innerSpin: false,
            depositBillRecordUuid: '',
            depositBillRecordUuidArray: [],
            orderRecord: {},
            pageLoading: false,
            orderDetail: {
                columns: [
                    {
						    title: '序号',
                        align: 'center',
                        width:'50',
						    render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
									 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
						    }
                    },
                    {
                        title: "品种编号",
                        key: "productCode"
                    },
                    {
                        title: "品种名称",
                        key: "productName"
                    },
                    {
                        title: "单位",
                        key: "unitName"
                    },
                    {
                        title: '数量',
                        align: 'center',
                        key: 'orderQuantity'
                        //    render: (h, params) => {
                        //    if(params.row.productCode&&params.row.productCode!="定金收取(%)"){
                        // 	   return h('input', {
                        // 		 domProps: {
                        // 			 value: params.row.orderQuantity
                        // 		 },
                        // 		 style:{
                        // 			 textAlign: "center"
                        // 		 },
                        // 		 on: {
                        // 			 change: (event) => {
                        // 				 params.row.orderQuantity = event.target.value;
                        // 				 this.updateRow(params.row);
                        // 				}
                        // 			}
                        // 		});
                        //    }
                        //   else{
                        // 	  return h('span',params.row.orderQuantity);
                        //   }
                        // }
                    },
                    {
                        title: '单价',
                        align: 'center',
                        key: 'preSalePlanPrice'
                        //    render: (h, params) => {
                        //    if(params.row.productCode&&params.row.productCode!="定金收取(%)"){
                        // 	   return h('input', {
                        // 		 domProps: {
                        // 		   value: params.row.preSalePlanPrice
                        // 		 },
                        // 		 style:{
                        // 			 textAlign: "center"
                        // 		 },
                        // 		 on: {
                        // 			 change: (event) => {
                        // 				 params.row.preSalePlanPrice = event.target.value;
                        // 				 this.updateRow(params.row);
                        // 			}
                        // 		 }
                        // 	   });
                        // 	}
                        //    else{
                        // 	  return h('span',params.row.preSalePlanPrice);
                        //    }
                        // }
                    },
                    {
                        title: '金额',
                        key: 'totalMoney'
                    }
                    // {
                    //     title: '操作',
                    //     key: 'action',
                    //     align: 'center',
                    //     width: 60,
                    //     render: (h, params) => {
                    // 			return h('div', [
                    // 			    h('Button', {
                    // 			        props: {
                    // 			            type: 'text',
                    // 			            size: 'small',
                    // 			            shape: 'circle'
                    // 			        },
                    // 					style:{
                    // 						visibility: (this.$checkAccessArray(['B', 'S'])&&params.row.depositBillDetailUuid)&&params.row.orderStatus!='撤单'&&params.row.depositBillRecordshipStatus=='未发货'&&params.row.paidStatus!='全额支付'? 'visible' : 'hidden'
                    // 					},
                    // 					on: {
                    // 					    click: () => {
                    // 					        this.cancelProduct(params.row);
                    // 					    }
                    // 					}
                    // 			    }, '撤销')
                    // 			]);
								
                    //     }
                    // }
                ],
                rows: []
            }
        };
    },
    computed: {},
    mounted() {
        //this.init();
    },
    methods: {
        updateRow(row){
            this.orderDetail.rows.forEach(item =>{
                if(row.depositBillDetailUuid==item.depositBillDetailUuid){
                    item.orderQuantity=row.orderQuantity;
                    item.preSalePlanPrice=row.preSalePlanPrice;
                }
            });
        },
        // updatePreSalePlanPrice(){
        // 	let preSalePlanPrice=this.orderDetail.rows[0].preSalePlanPrice;
        // 	this.orderDetail.rows.forEach(item =>{
        // 		if(item.productCode){
        // 			item.preSalePlanPrice=preSalePlanPrice;
        // 		}
        // 	});
        // },
        // saveDetailInfo(){
        // 	let sendDeliveryDateNew=this.sendDeliveryDate+" 00:00:00";
        // 	this.orderRecord.sendProductDate=sendDeliveryDateNew;
        // 	  this.orderRecord.orderItmeList.forEach(item =>{
        // 		  this.orderDetail.rows.forEach(e =>{
        // 			  if(item.depositBillDetailUuid&&item.depositBillDetailUuid==e.depositBillDetailUuid){
        // 				  item.orderQuantity = e.orderQuantity;
        // 				  item.preSalePlanPrice = e.preSalePlanPrice;
        // 			  }
        // 		  });
        // 	  });
        // 	  this.innerSpin = true;
        // 	  updateDepositBillDetailByUuid({depositBillMainRecordVO:this.orderRecord}).then(res => {
        // 		  this.innerSpin = false;
        // 		  if (res.code === 0) {
        // 			  this.innerSpin = true;
        // 			  getDepositBillOrderDetail({depositBillRecordUuid:this.depositBillRecordUuid}).then(res => {
        // 				  this.innerSpin = false;
        // 				  if (res.code === 0) {
        // 					  this.orderRecord = res.data.depositBillMainVOList[0];
        // 					  this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList;
        // 					  this.$parent.getMainTableRecords();
        // 					  this.$Message.success('修改的信息保存成功！');
        // 				  }
        // 			  }).catch(() => {
        // 				  this.innerSpin = false;
        // 			  });

        // 		  }
        // 	  });
        // },
        // cancel () {
        // 	this.$Message.info('请再次确认信息');
        // },
        // cancelProduct(row){
        // 	if(row.paidStatus!='定金已支付'){
        // 		this.$Message.info('当前定金单的支付状态不是定金已支付，不允许修改定金单！');
        // 		return;
        // 	}
        //     this.$showGlobalSpin();
        //     this.innerSpin = true;
        //     deleteDepositBillDetailByUuid({depositBillDetailUuid:row.depositBillDetailUuid}).then(res => {
        // 	  this.innerSpin = false;
        // 	  this.$hideGlobalSpin();
        // 	  if (res.code === 0) {
        // 		  this.innerSpin = true;
        // 		  getDepositBillOrderDetail({depositBillRecordUuid:this.depositBillRecordUuid}).then(res => {
        // 		      this.innerSpin = false;
        // 		      if (res.code === 0) {
        // 		          if (res.data.depositBillMainVOList.length > 0) {
        // 		              this.orderRecord = res.data.depositBillMainVOList[0];
        // 		              this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList;
        // 					  this.$parent.getMainTableRecords();
        // 					  this.$Message.success('撤销成功！');
        // 		          }
        // 				  else{
        // 					  this.show = false;
        // 					  this.$parent.getMainTableRecords();
        // 					  this.$Message.success('撤销成功！');
        // 				  }
        // 		      }
        // 			  else if(res.code === 11){
        // 				  this.$Message.info(res.message);
        // 			  }
        // 		  }).catch(() => {
        // 		      this.innerSpin = false;
        // 		  });
        // 	  }
        //   });
        // },
        formatDateString,
        formatDateTimeString,
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.depositBillRecordUuid = orderUuid;
            this.show = true;
        },
        init() {
            if (this.depositBillRecordUuid) {
                this.innerSpin = true;
                getDepositBillOrderDetail({ depositBillRecordUuid:this.depositBillRecordUuid }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        if (res.data.depositBillMainVOList != null&&res.data.depositBillMainVOList.length>0) {
                            this.orderRecord = res.data.depositBillMainVOList[0];
                            this.orderRecord.billCode=(this.orderRecord.billCode.split("_"))[0];
                            this.orderDetail.rows = res.data.depositBillMainVOList[0].orderItmeList;
                            this.sendDeliveryDate=formatDateString(res.data.depositBillMainVOList[0].depositBillRecordSendProductDate);
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        onSave() {

        }

    }
};
</script>

<style>
    .ivu-table-cell{
        text-align: center;
    }
    .ivu-table-small th{
        text-align: center;
       }
    .ivu-table th, .ivu-table td{text-align: center !important;}
    th.ivu-table-column-left, td.ivu-table-column-left{text-align: center !important;}
    th.ivu-table-column-right, td.ivu-table-column-right{text-align: center !important;}
</style>
